import React from "react";
import { Tooltip, Popover } from 'react-bootstrap';
import moment from 'moment';
import 'moment-timezone';
import { DeliveryService } from "./Services/DeliveryService";
import { UserService } from "./Services/UserService";
import {Tooltip as MuiTooltip, withStyles, TableCell} from '@material-ui/core';
import Config from "./Config";

const formatter = new Intl.NumberFormat('en-IN');

export function tooltip(text) {
    return (
    <Tooltip id="tooltip">
        <strong>{text}</strong>
    </Tooltip>
    );
}

export function formatQty(number){
    return formatter.format(number);
    // return parseFloat(number).toLocaleString('en-IN', {style: 'unit', minimumFractionDigits: 2, maximumFractionDigits: 2});
}

export function colorGenerator(count = 1){
    return ['#3333ff', '#CC0000', '#F38822', '#AAAAAA','#FF00FF', '#800000', '#C0C0C0','#808080','#000000','#FF0000','#808000','#00FF00','#008000','#00FFFF','#0000FF','#FF00FF','#800080','#0076CE','#008080','#04B000','#0B0F70','#275B4B','#2F8FD6','#466108','#5B6E31','#792C97','#800080','#972C95','#A3C0C6','#AE1D08','#B3D9FF','#B5BDC4','#BBEEFF','#BBFFEE','#C0F762','#C1D4CC','#C6A9A3','#C9DEEA','#CCAC95','#DAA520','#E1FCFF','#E1FFE4','#E5B8AD','#F797A5','#FCC00F','#FFE4E1','#FFF3CE'].slice(0, count);
    // return randomColor({count, luminosity: 'bright'});
}

export function randomHex(){
    let letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++ ) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

export function popover(text) {
    return (
    <Popover id="popover-top">
        <strong>{text}</strong>
    </Popover>
    );
}

export const format = 'YYYY-MM-DD HH:mm:ss';
export const format_fancy = 'Do MMM YYYY HH:mm:ss';
export const format_without_time = 'YYYY-MM-DD';
export const format_display = 'MM/DD/YYYY';
export const format_display_DDMMYYYY = 'DD/MM/YYYY';
export const format_export = 'DD/MM/YY';
export const format_date_only = 'DD MMM YYYY';
export const format_date_only_new = 'Do MMM YYYY';
export const format_display_fancy_notime = "Do MMM YYYY";
export const format_display_fancy_notime_withDay = "dddd, Do MMM";
export const format_fancy_notime = "DD MMM YYYY";
export const format_my = "MMM YYYY";
export const format_dm = "DD MMM";
export const format_display_date = "Do MMM YYYY HH:mm a";

export function getTimeInIST(dateString){
    const timeInUTC = moment.utc(dateString, format);
    return timeInUTC.clone().tz('Asia/Kolkata');
}

export function currentTimeInIST(){
    return moment.utc().clone().tz('Asia/Kolkata');
}

export function toInt(n){
    return parseInt(n, 10);
}


export function handleApproveStoreDeliveryChange(invoice_no, approver_user_id, headers = {}, success, error) {
    if(invoice_no && approver_user_id){
        let body = { invoice_no: invoice_no, approver_user_id: approver_user_id };
        DeliveryService.approveDeliveryChange(body, headers)
        .then((data) => {
            if(success){
                success(data);
            }
        })
        .catch((error_message) => {
            if(error_message){
                error(error_message);
            } 
        });
    }
}

export function handleApproveDeliveryChange(transaction_id, approver_user_id, headers = {}, success, error) {
    if(transaction_id && approver_user_id){
        let body = { transaction_id, approver_user_id };
        DeliveryService.approveDeliveryChange(body, headers)
        .then((data) => {
            if(success){
                success(data);
            }
        })
        .catch((error_message) => {
            if(error_message){
                error(error_message);
            } 
        });
    }
}

export function fetchStoreContracts(store_id, success, error){
    UserService.getStoreContractList(store_id)
    .then((data) => {
        let contractMap = new Map();
        data.contracts.forEach((contract) => {
            contractMap.set(contract.product_id, contract.commission);
        });
        if(success){
            success(contractMap);
        }
    })
    .catch(error_message => {
        console.log(error_message);
        if(error){
            error(error_message);
        }
    });
}

export function formatNumber(number, decimal = 2){
    return parseFloat(number).toLocaleString('en-IN', {style: 'currency', minimumFractionDigits: decimal, maximumFractionDigits: decimal, currency: 'INR'});
}

export function openMap(current_location){
    let location = current_location.split(",");
    window.open(Config.google_url+location[0]+","+location[1], "_blank");
}

export function getColor(status_code){
    let color;
    switch (status_code) {
        case "1":
            color = "primary"
            break;
        case "0":
            color = "textPrimary"
            break;
        case "-1":
            color = "secondary"
            break;
        case "2":
            color = "secondary"
            break;
        default:
            color = "textPrimary"
            break;
    }
    return color;
}

export function getColorStoreStatus(status_code){
    let color;
    switch (status_code) {
        case "1":
            color = "primary"
            break;
        case "0":
            color = "secondary"
            break;
        case "-1":
            color = "secondary"
            break;
        case "-2":
            color = "textPrimary"
            break;
        default:
            color = "textPrimary"
            break;
    }
    return color;
}

export function translateStatus(status_code){
    let status;
    switch (status_code) {
        case "1":
            status = "Successful"
            break;
        case "0":
            status = "Started"
            break;
        case "-1":
            status = "Failed"
            break;
        case "2":
            status = "Re-run"
            break;
        default:
            status = '-'
            break;
    }
    return status;
}

export function translateStatusCode(status_code){
    let status;
    switch (status_code) {
        case "1":
            status = "S"
            break;
        case "0":
            status = "I"
            break;
        case "-1":
            status = "F"
            break;
        case "2":
            status = "Re"
            break;
        default:
            status = '-'
            break;
    }
    return status;
}

export function transalateReason(status){
    let reason;
    switch (status) {
        case "1":
            reason = "Scheduled deliveries"
            break;
        case "0":
            reason = "Conditions Failed"
            break;
        case "-2":
            reason = "Already scheduled"
            break;
        default:
            reason = '-'
            break;
    }
    return reason;
}

export function convertDistance(value){
    if(value < 1) {
        return  "1m";
    } else if(value < 1000) {
        return value.toFixed(2) + "m";
    } else {
        var km = value / 1000;
        return km.toFixed(1) + "km";
    }
}

export function isInt(n) {
    return n % 1 === 0;
}

export function openLink(link){
    window.open(link, "_blank")
}

export const HtmlTooltip = withStyles((theme) => ({
    arrow: {
      color: theme.palette.common.black,
    },
    tooltip: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      maxWidth: 350,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }))(MuiTooltip);

  export const StyledTableCell = withStyles((theme) => ({
    root: {
        paddingLeft: 16, 
        paddingRight: 16,
        borderBottom: '1px solid rgba(238, 238, 238, 1)',
        fontSize: 14,
        height: 35,
    }
  }))(TableCell);